import { isEventLiveBySchedule, getWeekdayLabel } from "./time";
import { EVENT_STATUS, CONTENT_TYPE, SIDE_PANEL_ACTIONS } from "../../constants/event";

// Returns true if `item` matches the content currently playing on screen.
export function isContentNowPlaying(item, activeLiveContent) {
    if (!activeLiveContent || !item) return false;
    if (item.contentType === CONTENT_TYPE.LIVE_CHANNEL) {
        return activeLiveContent.contentType === CONTENT_TYPE.LIVE_CHANNEL && activeLiveContent.id === item.id;
    }
    const isActiveStatus = item.status === EVENT_STATUS.LIVE || item.status === EVENT_STATUS.COMING;
    return isActiveStatus && activeLiveContent.contentType === CONTENT_TYPE.LIVE_EVENT && activeLiveContent.id === item.id;
}

export function getEventCardStatus(event, activeLiveContent) {
    const isChannel = event.contentType === CONTENT_TYPE.LIVE_CHANNEL;
    const nowPlaying = isContentNowPlaying(event, activeLiveContent);

    if (isChannel) {
        return { isNowPlaying: nowPlaying, isLive: true, isScheduledFlag: false, liveButtonText: EVENT_STATUS.LIVE };
    }

    const isLiveByClock = isEventLiveBySchedule(event.schedule_start, event.schedule_end);
    // isLive includes clock-based check and COMING status so the "LIVE" badge appears
    // optimistically, before the backend has confirmed the transition.
    const isLive = nowPlaying || isLiveByClock || event.status === EVENT_STATUS.COMING;
    const isScheduledFlag = !isLive && (event.status === EVENT_STATUS.SCHEDULED || event.status === EVENT_STATUS.COMING);
    const weekdayLabel = isScheduledFlag && event.schedule_start ? getWeekdayLabel(event.schedule_start) : null;
    const liveButtonText = isLive ? EVENT_STATUS.LIVE : (weekdayLabel ?? event.status);

    return { isNowPlaying: nowPlaying, isLive, isScheduledFlag, liveButtonText };
}

// Priority cascade for the side-panel button action:
//   1. Channels → always PLAY
//   2. LIVE event already playing → REMOVE (stop watching)
//   3. LIVE/COMING event not playing → PLAY (start watching)
//   4. Scheduled event, subscribed → REMOVE (unsubscribe)
//   5. Scheduled event, not subscribed → ADD (subscribe)
export function getSidePanelAction(event, isNowPlaying, isSubscribed) {
    if (event.contentType === CONTENT_TYPE.LIVE_CHANNEL) return SIDE_PANEL_ACTIONS.PLAY;
    if (event.status === EVENT_STATUS.LIVE && isNowPlaying) return SIDE_PANEL_ACTIONS.REMOVE;
    if ([EVENT_STATUS.LIVE, EVENT_STATUS.COMING].includes(event.status)) return SIDE_PANEL_ACTIONS.PLAY;
    if (isSubscribed) return SIDE_PANEL_ACTIONS.REMOVE;
    return SIDE_PANEL_ACTIONS.ADD;
}
